import React from 'react';
export function Banner() {
  return <div className="w-full flex items-center justify-center fixed bottom-0 left-0 z-50 bg-[#F9F9F9]" style={{
    height: 90
  }} data-id="element-181">
      <a href="https://maleup.de/products/quiz-deal-3x-anti-aging-face-cream?variant=52835646537995" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center relative bg-[#000000] mx-4" style={{
      maxWidth: 380,
      width: '100%',
      minHeight: 76,
      borderRadius: 4,
      boxShadow: '0px 4px 7px 1px rgba(0,0,0,0.19)',
      fontFamily: 'Figtree, sans-serif',
      padding: '12px 20px'
    }} data-id="element-182">
        <span className="font-bold text-center" style={{
        fontSize: 19,
        lineHeight: '26px',
        color: '#F6F9FE'
      }} data-id="element-183">
          Jetzt 60€ Rabatt & GRATIS Produkt sichern →
        </span>
      </a>
    </div>;
}